import { useCallback, useMemo } from 'react';
import { twJoin } from 'tailwind-merge';

interface Props {
    id: string;
    label: string;
    active?: boolean;
    onClick?: (id: string) => void;
    variant?: 'card' | 'underline';
}

export function TabButton({ id, label, active, onClick, variant }: Props) {
    const handleClick = useCallback(() => {
        onClick?.(id);
    }, [id, onClick]);

    const className = useMemo(() => {
        switch (variant) {
            case 'card':
                return twJoin(
                    'relative flex-shrink-0 flex-grow select-none rounded-t-md border px-4 py-2',
                    active
                        ? 'border-x-neutral-150 border-b-white border-t-neutral-150 bg-white text-primary-500'
                        : 'border-neutral-150 bg-neutral-50',
                );
            case 'underline':
                return twJoin(
                    'py-4 border-b-3 translate-y-px font-medium text-nowrap',
                    !active && 'border-transparent text-neutral-500',
                    active && 'border-primary-500 text-primary-500',
                );
        }
    }, [active, variant]);

    return (
        <button
            type="button"
            role="tab"
            aria-selected={active ?? false}
            aria-controls={`tab-panel-${id}`}
            onClick={handleClick}
            className={className}>
            {label}
        </button>
    );
}
